import React from 'react';
import './FreeShipping.css';
import bg from '../assets/free_shipping.jpg';

export default function FreeShipping() {
  return (
    <section className="full-section free-shipping" style={{ backgroundImage: `url(${bg})` }}>
      <div className="fs-inner container">
        <div className="fs-icon" >
            <i className="fas fa-truck" style={{color:'#fff', fontSize:"70px"}} aria-hidden="true"></i>
        </div>
        <div className="fs-content">
          <h4>Free Shipping Australia Wide</h4>
          <p>We offer free delivery to all Australian regions for all orders placed over our website.</p>
        </div>
      </div>
    </section>
  );
}
